import styled from 'styled-components'

export const SettingTitleSection = styled.div`
	font-size: 30px;
	font-weight: 400;
	letter-spacing: 1px;
	color: ${p => p.theme.COLORS.textw};
`
